import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "d-flex justify-end mb-5" }
const _hoisted_6 = { class: "btn-area" }

import { useAuth } from "@/services/user/Auth0UserProvider"
import i18n from '@/lang/i18n'
import Api from "@/services/api/ApiServiceFabrick"
import { Ref, ref, reactive, onMounted, watch } from 'vue'
import subManagementOfficeType from "@/types/subManagementOffice"
import getSubManagementOffice from "@/types/requests/getSubManagementOffice"
import getPagenatedSubManagementOffice from "@/types/responses/getPagenatedSubManagementOffice"
import PaginateWithCount from "@/components/PaginateWithCount.vue"
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import { useRouter } from 'vue-router'
import SubManagementList from "@/components/SubManagementOfficeList/SubManagementList.vue"
import SerchForm from "@/components/SubManagementOfficeList/SerchForm.vue"
import FileDownloadBtn from "@/components/Files/DownloadButton.vue"
import FileUploadModal from "@/components/Files/UploadModal.vue"
import { SUB_MANAGEMENT_OFFICE_CSV_IMPORT_TYPE, SUB_MANAGEMENT_OFFICE_ICE_EXPORT_TYPE } from "@/services/consts"
import { saveDataToSessionStorage, loadDataFromSessionStorage, clearSessionStorage } from "@/services/functions/sessionStorage";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubManagementOfficeList',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

document.title = i18n.global.t('pages.subManagementOffice.title.listTitle')
const { loginWithRedirect } = useAuth()
const changeStatusAuthority: Ref<boolean> = ref(false)
const createAuthority: Ref<boolean> = ref(false)
const viewAuthority: Ref<boolean> = ref(false)
const showableImportCsvButton: Ref<boolean> = ref(false)
const showableExportCsvButton: Ref<boolean> = ref(false)
const currentPage: Ref<number> = ref(1)
const totalPage: Ref<number> = ref(0)
const itemsPerPage: Ref<number> = ref(50)
const allElementsCount: Ref<number> = ref(0)
const isLoading: Ref<boolean> = ref(false)
const updatingStatus: Ref<boolean> = ref(false)
const subManagementOffices: Ref<subManagementOfficeType[]> = ref([])
const errors: Ref<any> = ref({})
const router = useRouter()
const windowInnerWidth = ref(window.innerWidth);
const isManagementOffice: Ref<boolean> = ref(false);
const searchParams: getSubManagementOffice = reactive({
  page: 1,
  sort: "id",
  sort_type: "ASC",
  status: 'only-active',
  search: "",
});
const csvModalState: Ref<boolean> = ref(false);

window.addEventListener('resize', handleResize);

const props = __props

onMounted(() => {
  getAuthorityList()
  getSelf()
  const savedSearchParams = loadDataFromSessionStorage('subManagementOfficeSearchParams')
  if (savedSearchParams) {
    searchParams.search = savedSearchParams.search
    searchParams.status = savedSearchParams.status
  }
  getSubManagementOffices()
})

async function getAuthorityList(isError = false) {
  if (isError) {
    await AuthorityCacheApi.reflesh()
  }
  const authorityList = await AuthorityCacheApi.getWithParse()
  createAuthority.value = authorityList["octlink.submanagement_office.create"]
  changeStatusAuthority.value = authorityList["octlink.submanagement_office.delete"]
  viewAuthority.value = authorityList["octlink.submanagement_office.read"]
  showableImportCsvButton.value = authorityList["octlink.submanagement_office.input"]
  showableExportCsvButton.value = authorityList["octlink.submanagement_office.output"]
}

function getSelf() {
  Api().getSelfAccount().then((data) => {
    isManagementOffice.value = (data.login_organization_type == 'App\\Models\\ManagementOffice')
  }).catch((error) => {
    return errorHandle(error.response)
  })
}

function getSubManagementOffices() {
  isLoading.value = true
  Api().searchSubManagementOffice(searchParams).then((data: getPagenatedSubManagementOffice) => {
    subManagementOffices.value = data.data
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
    isLoading.value = false
  }).catch((error: any) => {
    return errorHandle(error.response)
  })
}

function searchList (form: getSubManagementOffice) {
  searchParams.page = 1
  searchParams.status = form?.status
  searchParams.search = form?.search
  saveDataToSessionStorage('subManagementOfficeSearchParams', searchParams)
  getSubManagementOffices()
} 

function changeSortOrder (sortItem: string, sortType: string) {
  searchParams.sort = sortItem
  searchParams.sort_type = sortType
  if (currentPage.value == 1) {
    getSubManagementOffices()
  } else {
    currentPage.value = 1;
  }
}

function updateStatus (params: subManagementOfficeType) {
  updatingStatus.value = true
  Api().updateSubManagementOfficeStatus(params.id, params).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.changeStatusSuccess'), "success", true)
    updatingStatus.value = false
    getSubManagementOffices()
  }).catch((error) => {
    if (error.response.status == 403) {
      getAuthorityList(true)
    }
    return errorHandle(error.response)
  })
}

function moveToForm () {
  router.push('/sub-management-offices/form/')
}

function errorHandle (res: any) {
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      isLoading.value = false
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      isLoading.value = false
      break
    case 422:
      errors.value = res.data.errors
  }
  return updatingStatus.value = false
}

function handleResize() {
  windowInnerWidth.value = window.innerWidth;
}

function inactivateModalState(isReacquireVehicle: boolean) {
  csvModalState.value = false;
  if (isReacquireVehicle) {
    searchParams.page = 1
    getSubManagementOffices();
  }
}

function clearSubManagementOfficeSearchParams() {
  clearSessionStorage('subManagementOfficeSearchParams')
}

watch(currentPage, () => {
  searchParams.page = currentPage.value
  getSubManagementOffices()
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.subManagementOffice.title.listTitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (viewAuthority.value && createAuthority.value && isManagementOffice.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "exec-btn mt-0",
                onClick: moveToForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.newCreate')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(FileDownloadBtn, {
            showable: showableExportCsvButton.value,
            btnClass: "exec-btn mt-0 ml-1",
            btnName: _unref(i18n).global.t('pages.common.button.csvExport'),
            type: _unref(SUB_MANAGEMENT_OFFICE_ICE_EXPORT_TYPE),
            filterItems: searchParams
          }, null, 8, ["showable", "btnName", "type", "filterItems"]),
          _withDirectives(_createVNode(_component_v_btn, {
            class: "exec-btn mt-0 ml-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (csvModalState.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.csvImport')), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, showableImportCsvButton.value]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(SubManagementList, {
          class: "mb-2",
          subManagementOffices: subManagementOffices.value,
          isLoading: isLoading.value,
          changeStatusAuthority: changeStatusAuthority.value,
          updatingStatus: updatingStatus.value,
          onChangeStatus: updateStatus,
          onChangeSortOrder: changeSortOrder
        }, null, 8, ["subManagementOffices", "isLoading", "changeStatusAuthority", "updatingStatus"]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
          itemsPerPage: itemsPerPage.value,
          allElementsCount: allElementsCount.value,
          showItemCount: true
        }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"]),
        _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1))
      ])
    ]),
    _createVNode(SerchForm, {
      isLoading: isLoading.value,
      onSearch: searchList,
      onClear: clearSubManagementOfficeSearchParams
    }, null, 8, ["isLoading"]),
    _createVNode(FileUploadModal, {
      modalState: csvModalState.value,
      title: _unref(i18n).global.t('pages.subManagementOffice.list.csvImportModalTitle'),
      uploadBtnClass: "exec-btn mt-0 ml-1",
      closeBtnClass: "mt-0",
      type: _unref(SUB_MANAGEMENT_OFFICE_CSV_IMPORT_TYPE),
      templateCsvFileType: "submanagement_offices",
      onCloseModal: inactivateModalState
    }, null, 8, ["modalState", "title", "type"])
  ]))
}
}

})